import Karaoke from "../Views/Karaoke";

const routes = [{ path: "/karaoke", element: <Karaoke /> }];

export default routes;
